

























import Vue from 'vue'

import { IArticle } from '../store/state'


interface ArticleProperty {
	article: IArticle,
}

export default Vue.extend<{}, {}, {} , ArticleProperty>({
	name: 'Article',
	props: {
		article: {}
	}
})
